export default __webpack_public_path__ + "static/media/qemotion-icon.a4e1a738.png";